<template>
  <v-sheet class="fill-height" tile color="#ffffff" >
    <v-container fluid>
      <v-row>
        <v-col v-for="store in allFavoritesStores" cols="12" lg="4" xs="12" sm="6" md="6" :key="store.id">
          <StoreTile mode="visit" :store="store"></StoreTile>
        </v-col>
        <v-col v-if="allFavoritesStores.length == 0" align="center">
        <div class="no-data">
              <div>
                <v-img width="156" class="mb-6" src="/static/no_data_favorites.svg"/>
                <span>
                   Save your favorite places
                </span>
              </div>
            </div>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>
  import {mapGetters} from "vuex";
  import StoreTile from "../Stores/StoreTile";
  const moment = require('moment-timezone')

  export default {
    name: "Favorites",
    components: {StoreTile},
    computed: {
      ...mapGetters(['allFavorites', 'getStoreById']),
      allFavoritesStores() {
        var result = []
        var favs = this.allFavorites.sort((a, b) => moment(a.createdAt) < moment(b.createdAt) ? 1 : -1 )
        for (var fav of favs) {
          var store = this.getStoreById(fav.store_id)
          if (store) {
            result.push(store)
          }
        }
        return result
      }
    },
    mounted: function () {
        this.$store.dispatch('reloadFavorites')
    }
  }
</script>



// WEBPACK FOOTER //
// src/Pages/Favorites.vue